// Is the logged-in AkountFly user also a partner? Powers the header "Partner Portal" link (fetched once per session).
import { useEffect, useState } from 'react';
import apiClient from '../utils/apiClient';

let cached = null;
export const usePartnerPortalLink = (user) => {
  const [state, setState] = useState(cached || { is_partner: false });
  useEffect(() => {
    if (!user?.email) return;
    if (cached && cached.email === user.email) { setState(cached); return; }
    apiClient.get('/partner-portal/my-partner-link')
      .then((r) => { cached = { ...r.data, email: user.email }; setState(cached); })
      .catch(() => {});
  }, [user?.email]);
  return state;
};
